//MOBILE
import React from "react";
import Hero from "./hero/hero";

const HeaderSmall = () => {
  return (
    <div className="relative overflow-hidden">
      <Hero />
    </div>
  );
};

export default HeaderSmall;
